import React, { ReactElement, useContext } from 'react'
import styled from 'styled-components'

import { graphql, useStaticQuery } from 'gatsby'
import dayjs from 'dayjs'
import { Article } from '~src/types/article'
import LanguageContext from '~components/homepage/context/language-context'
import { findImages } from '~components/homepage/utils'
import { DefaultImage } from '~components/homepage/styled/shared'
import { mediaQueries } from '~components/homepage/styled/constants'
import { ImagesQueryData } from '~src/types/graphql-types'
import {
  ArticleDate,
  ArticleDescription,
  ArticleTitle,
  Divider,
} from './styled/shared'

const HeadArticleContainer = styled.div`
  display: grid;
  grid-template-columns: 2fr 1fr;
  gap: 40px;
  align-items: end;
  margin-bottom: 20px;

  @media (max-width: ${mediaQueries.medium}) {
    & {
      margin-top: 50px;
      grid-template-columns: 1fr;
      padding: 20px;
      gap: 10px;
    }
  }
`

interface Props {
  article: Article
}

const HeadArticle: React.FC<Props> = ({ article }): ReactElement => {
  const { lang } = useContext(LanguageContext)

  const currentArticle = lang === 'EN' && article.en ? article.en : article

  const data = useStaticQuery<ImagesQueryData>(
    graphql`
      query {
        allFile(filter: { sourceInstanceName: { eq: "images" } }) {
          edges {
            node {
              childImageSharp {
                fluid(quality: 100, maxWidth: 1000) {
                  originalName
                  ...GatsbyImageSharpFluid
                }
              }
              name
            }
          }
        }
      }
    `
  )

  const sliderImages = findImages(data, [currentArticle.mainPicture.src])

  return (
    <div>
      <HeadArticleContainer>
        <DefaultImage
          fluid={sliderImages[0]?.node.childImageSharp.fluid}
          height="450px"
          width="100%"
        />
        <div>
          <ArticleDate style={{ marginBottom: 15 }}>
            {dayjs(currentArticle.date).format('DD.MM.YYYY')}
          </ArticleDate>
          <ArticleTitle style={{ marginBottom: 10 }}>
            {currentArticle.title}
          </ArticleTitle>
          <ArticleDescription>
            {[currentArticle.content?.[0], currentArticle.content?.[1]]
              .filter(item => item && item.type === 'p')
              .map(item => (item as any).content)
              .join(' ')
              .substring(0, 400)}
            ...
          </ArticleDescription>
        </div>
      </HeadArticleContainer>
      <Divider />
    </div>
  )
}

export default HeadArticle
